import React, { useCallback } from "react";
import { Button, AccordionActions } from "@material-ui/core";
import type { FC } from "react";
import { useStyles } from "./Actions.styles";
import { getNextStepIndex, getPrevStepIndex } from "./Actions.utils";
import { ExportTriggerButton } from "../../../ExportTriggerButton";
import type { IActionsProps } from "./Actions.types";
import { SaveBulkExportStateButton } from "../../../SaveBulkExportStateButton/SaveBulkExportStateButton";
import { useBulkExportContext } from "../../../../providers";
import { SaveAsBulkExportStateButton } from "../../../SaveAsBulkExportStateButton/SaveAsBulkExportStateButton";
import { DeleteBulkExportStateButton } from "../../../DeleteBulkExportStateButton/DeleteBulkExportStateButton";
import { ExportSubscribeButton } from "../../../ExportSubscribeButton";

export const Actions: FC<IActionsProps> = (props) => {
  const classes = useStyles();
  const { allSteps, index, onChangeStep, isBulkFavourite, isBulkSubscibtion } = props;

  const prevStepIndex = getPrevStepIndex(allSteps, index);
  const nextStepIndex = getNextStepIndex(allSteps, index);
  const isSaved = Boolean(useBulkExportContext()?.state.tab);
  const hasPrevStep = Boolean(~prevStepIndex);
  const hasNextStep = Boolean(~nextStepIndex);

  const handlePrevStep = useCallback(() => onChangeStep?.(prevStepIndex), [prevStepIndex]);
  const handleNextStep = useCallback(() => onChangeStep?.(nextStepIndex), [nextStepIndex]);

  const isNotBulkFavouriteAndBulkSubscibtion = !isBulkFavourite && !isBulkSubscibtion;

  return (
    <AccordionActions className={classes.actions} id={`${index}bh-footer`}>
      <div>
        <Button size="small" disabled={!hasPrevStep} onClick={handlePrevStep} className={classes.btnPagination}>
          Previous{" "}
        </Button>
        {hasNextStep ? (
          <Button size="small" onClick={handleNextStep} className={classes.btnPagination}>
            Next{" "}
          </Button>
        ) : (
          isNotBulkFavouriteAndBulkSubscibtion && (
            <>
              {<ExportTriggerButton />}
              {<ExportSubscribeButton />}
            </>
          )
        )}
      </div>
      {!hasNextStep && (
        <div>
          {isSaved && <SaveBulkExportStateButton />}
          {isNotBulkFavouriteAndBulkSubscibtion && <SaveAsBulkExportStateButton />}
          {isSaved && <DeleteBulkExportStateButton />}
        </div>
      )}
    </AccordionActions>
  );
};
